<div class="c-content c-content--border-bottom u-no-pt u-no-ph@md-and-up u-hidden@up-to-md">
	<div class="o-grid">
		<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
			<p class="c-text c-text--gray" aria-hidden="true">{{ 'Booking.Instant.Type' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
			<p class="c-text c-text--gray" aria-hidden="true">{{ 'Booking.Instant.Languages' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
			<p class="c-text c-text--gray" aria-hidden="true">{{ 'Booking.Instant.Method' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-45 u-no-p">
			<p class="c-text c-text--gray" aria-hidden="true">{{ 'Common.Description' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
			<p class="c-text c-text--gray" aria-hidden="true">{{ 'Booking.Instant.Time_Left' | translate }}</p>
		</div>
	</div>
</div>
<ul class="c-list">
	<li *ngFor="let booking of vm.bookings ; let $index=index ; let $last = last">
		<div class="c-content u-no-ph@md-and-up" [ngClass]="{'c-content--border-bottom': !$last}">
			<div class="o-grid o-grid--wrap@up-to-md u-ost-sm@md-and-up">
				<div class="o-grid__cell o-grid__cell--baseline o-grid__cell--w-fill o-grid__cell--w-10@md-and-up u-no-p">
					<span class="u-sr-only">{{ 'Booking.Instant.Type' | translate }}</span>
					<p class="c-text c-text--bold@up-to-md c-text--lg@up-to-md">{{ (booking.type === 'PRESCRIPTION_REQUEST' ? 'Booking.Prescription.Prescription' : 'Subscription.Label.Consultation') | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--baseline o-grid__cell--w-100 o-grid__cell--w-15@md-and-up o-grid__cell--o3@up-to-md u-no-p u-ost-md@up-to-md u-osb-md@up-to-md" [ngSwitch]="booking.type">
					<span class="u-sr-only">{{ 'Booking.Instant.Languages' | translate }}</span>
					<p class="c-text" *ngSwitchCase="'PRESCRIPTION_REQUEST'">{{ 'Common.N_A' | translate }}</p>
					<list-language-flags [languages]="booking.languages" *ngSwitchDefault></list-language-flags>
				</div>
				<div class="o-grid__cell o-grid__cell--baseline o-grid__cell--w-100 o-grid__cell--w-10@md-and-up o-grid__cell--o2@up-to-md u-no-p" [ngSwitch]="booking.type">
					<span class="u-sr-only">{{ 'Booking.Instant.Method' | translate }}</span>
					<p class="c-text" *ngSwitchCase="'PRESCRIPTION_REQUEST'">{{ 'Common.N_A' | translate }}</p>
					<p class="c-text" *ngSwitchDefault>{{ 'Booking.CommunicationType.' + booking.communicationType | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--baseline o-grid__cell--w-100 o-grid__cell--w-45@md-and-up o-grid__cell--o2@up-to-md u-no-p u-ost-md@up-to-md" [ngSwitch]="booking.type">
					<span class="u-sr-only">{{ 'Common.Description' | translate }}</span>
					<p class="c-text u-ost-md@up-to-md" *ngSwitchCase="'PRESCRIPTION_REQUEST'">{{ vm.getPrescriptionDescription(booking) }}</p>
					<p class="c-text" *ngSwitchDefault>{{ booking.comment }}</p>
					<p class="c-text c-text--gray u-ost-sm" *ngIf="booking.interview.localId">
						<i class="o-icon o-icon--patch" aria-hidden="true"></i>
						{{ 'Symptom_Check.Added' | translate }}
					</p>
				</div>
				<div class="o-grid__cell o-grid__cell--baseline o-grid__cell--w-fixed o-grid__cell--w-5@md-and-up o-grid__cell--o1@up-to-md u-no-p">
					<span class="u-sr-only">{{ 'Booking.Instant.Time_Left' | translate }}</span>
					<p class="c-text c-text--s3 c-text--bold@up-to-md c-text--lg@up-to-md">{{ booking.timeLeft }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right o-grid__cell--o4@up-to-md u-no-p u-no-m@up-to-md o-grid__cell--baseline" [ngStyle]="{marginTop: booking.interview.localId ? '-12px' : '-3px'}">
					<button id="handleInstantBookingAcceptButton{{$index}}" type="button" class="c-button c-button--s2 c-button--narrow c-button--fit" (click)="vm.handleBookingAccept(booking)" [disabled]="booking.isAccepting">{{ 'Common.Accept' | translate }}</button>
				</div>
			</div>
		</div>
	</li>
</ul>
